// @flow

import React from 'react';
import 'app/common/react/components/common/ExperimentalLegoGestalt/LegoGestalt.scss';
import Pog from 'app/common/react/components/common/ExperimentalLegoGestalt/Pog';

type Props = {|
  accessibilityExpanded?: boolean,
  accessibilityHaspopup?: boolean,
  accessibilityLabel: string,
  bgColor?: 'transparent' | 'transparentDarkGray' | 'gray' | 'lightGray' | 'white' | 'red',
  disabled?: boolean,
  icon: string,
  iconColor?: 'gray' | 'darkGray' | 'red' | 'blue' | 'white',
  iconSize?: number,
  onClick?: ({ event: SyntheticMouseEvent<> }) => void,
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl',
  wrappingPogStyle?: {|
    transform: string,
    transition: string,
  |},
|};

type State = {|
  active: boolean,
  focused: boolean,
  hovered: boolean,
|};

export default class IconButton extends React.Component<Props, State> {
  state: State = {
    active: false,
    focused: false,
    hovered: false,
  };

  handleBlur = () => this.setState({ focused: false });

  handleFocus = () => {
    this.setState({ focused: true });
  };

  handleMouseDown = () => {
    this.setState({ active: true });
  };

  handleMouseEnter = () => {
    this.setState({ hovered: true });
  };

  handleMouseLeave = () => {
    this.setState({
      active: false,
      hovered: false,
    });
  };

  handleMouseUp = () => {
    this.setState({ active: false });
  };

  render() {
    const {
      accessibilityExpanded,
      accessibilityHaspopup,
      accessibilityLabel,
      bgColor,
      disabled,
      icon,
      iconColor,
      iconSize,
      onClick,
      size,
      wrappingPogStyle,
    } = this.props;

    const { active, focused, hovered } = this.state;

    return (
      <button
        aria-expanded={accessibilityExpanded}
        aria-haspopup={accessibilityHaspopup}
        aria-label={accessibilityLabel}
        className="LegoGestalt_IconButton"
        disabled={disabled}
        onBlur={this.handleBlur}
        onClick={(event) => onClick && onClick({ event })}
        onFocus={this.handleFocus}
        onMouseDown={this.handleMouseDown}
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
        onMouseUp={this.handleMouseUp}
        title={accessibilityLabel}
        type="button"
      >
        <div style={{ ...(wrappingPogStyle || {}) }}>
          <Pog
            active={active}
            bgColor={bgColor}
            focused={focused}
            hovered={hovered}
            icon={icon}
            iconColor={iconColor}
            iconSize={iconSize}
            size={size}
            title={accessibilityLabel}
          />
        </div>
      </button>
    );
  }
}
